
import { Browse } from "@/models/browse";
import { HumanFilter } from "@/utils/human-filter";
import { Model } from "@/utils/models/model";
import { ViewTotal } from "@/utils/views/view-total";
import Vue from "vue";
import AppTotalEditContentWrapper from "./TotalEditContentWrapper.vue";
import AppTotalEditFilterItem from "./TotalEditFilterItem.vue";

export default Vue.extend({
	data(){
		return {
			selectedFilter: null as null | HumanFilter
		};
	},
	props: {
		currentTab: {
			type: Number,
			required: true
		},
		value: {
			type: Object as ()=>ViewTotal,
			required: true
		},
		model: {
			type: Object as ()=>Model,
			required: true
		},
		browse: {
			type: Object as ()=>Browse,
			required: true
		}
	},
	methods: {
		async addFilter(){
			let filter = new HumanFilter();
			filter.Field = "this.ID";
			filter.Operator = ">";
			filter.Values = ["0"];
			this.value.Filters.push(filter);
			await this.$nextTick();
			this.selectedFilter = filter;
		},
		editFilter(i:number){
			if (this.selectedFilter == this.value.Filters[i]){
				this.selectedFilter = null;
			}else{
				this.selectedFilter = this.value.Filters[i];
			}
		},
		removeFilter(i:number){
			this.value.Filters.splice(i, 1);
		},
	},
	components: {
		AppTotalEditContentWrapper,
		AppTotalEditFilterItem
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
